<template>
  <main class="l-main h-bg-wood"></main>
</template>

<script>
import moment from "moment";
import VueGtag from "vue-gtag";
import Vue from "vue";


export default {
  name: "Boot",
  data() {
    return {
      to     : null,
      inited : false,
    };
  },
  computed:{
    customer(){
      return this.$store.getters.customer;
    },
    config(){
      return this.$store.getters.config;
    },
    site(){
      return this.$store.getters.site;
    },
  },
  watch:{
    customer(){
      this.init();
    },
    config(){
      this.init();
    },
    site(){
      this.init();
    },
  },
  mounted() {
    this.$root.$emit('toggleFooter',false);
    if(this.$store.getters.customer && this.$store.getters.config && (this.$route.params.siteId && this.$store.getters.site)){
      this.init();
    }else{
      this.$store.dispatch('getCustomer');
      this.$store.dispatch('getConfig');
      this.$store.dispatch('getSite');
    }
  },
  methods:{
    init(){

      if(!this.config || !this.customer || (this.$route.params.siteId && !this.site)) return
      if(this.inited===true) return;

      if(this.$store.getters.isBooted!==true){
        this.initAnalytics();
        this.initIcons();
        document.getElementById('app').style = {opacity:0};
      }

      this.inited=true;
      this.$store.commit('isBooted');
      this.$store.dispatch('getSite');

      if (this.$store.getters.isAuthed) {

            this.$store.dispatch('getUser');

            console.log('boot: is authed',this.$store.getters.refresh_token);

            if (moment().isAfter(moment(this.$store.getters.authExpireDate).startOf("day")) || this.$store.getters.refresh_token) {
              console.log('boot: now is after expiry');
              this.$store.dispatch("refreshAccess");
            } else {
              this.$store.dispatch("getSite");
              let page = (this.$store.getters.page!=="/")?this.$store.getters.page:"/select-site";
              if(page!=='/select-site')this.$root.$emit('toggleFooter',true);
            }

      } else {

        let page;
        if (window.linkedPage) {
          page = window.linkedPage;
          window.linkedPage = null
        }else if(this.$store.getters.moduleActive("app.intro")){
          page = "/intro";
        }else if(this.$store.getters.moduleActive("app.account")){
          page = "/login/options";
        }else{
          page = "/select-site";
        }
        this.$router.replace(page);

      }


    },
    initAnalytics(){
      if(!window.cordova && this.customer.analytics_key) {
        Vue.use(VueGtag, {
          config: { id: this.customer.analytics_key },
          appName: this.customer.name,
          pageTrackerScreenviewEnabled: true
        }, this.$router);
      }
    },
    initIcons(){

      document.title = this.customer.name;

      if(this.customer.favicon!==null){
        let link = document.createElement('link');
            link.rel = "icon";
            link.type = "image/x-icon";
            link.href = process.env.VUE_APP_STORAGE_BASE+this.customer.favicon;
        document.head.appendChild(link);

        let link2 = document.createElement('link');
            link2.rel = "shortcut icon";
            link2.type = "image/x-icon";
            link2.href = process.env.VUE_APP_STORAGE_BASE+this.customer.favicon;
        document.head.appendChild(link2);
      }

      if(this.customer.apple_36!==null){
        let link36 = document.createElement('link');
        link36.rel = "apple-touch-icon";
        link36.sizes = "36x36";
        link36.href = process.env.VUE_APP_STORAGE_BASE+this.customer.apple_36;
        document.head.appendChild(link36);
      }

      if(this.customer.apple_48!==null){
        let link48 = document.createElement('link');
        link48.rel = "apple-touch-icon";
        link48.sizes = "48x48";
        link48.href = process.env.VUE_APP_STORAGE_BASE+this.customer.apple_48;
        document.head.appendChild(link48);
      }

      if(this.customer.apple_57!==null){
        let link3 = document.createElement('link');
            link3.rel = "apple-touch-icon";
            link3.sizes = "57x57";
            link3.href = process.env.VUE_APP_STORAGE_BASE+this.customer.apple_57;
        document.head.appendChild(link3);
      }

      if(this.customer.apple_72!==null){
        let link4 = document.createElement('link');
        link4.rel = "apple-touch-icon";
        link4.sizes = "72x72";
        link4.href = process.env.VUE_APP_STORAGE_BASE+this.customer.apple_72;
        document.head.appendChild(link4);
      }

      if(this.customer.apple_96!==null){
        let link96 = document.createElement('link');
        link96.rel = "apple-touch-icon";
        link96.sizes = "96x96";
        link96.href = process.env.VUE_APP_STORAGE_BASE+this.customer.apple_96;
        document.head.appendChild(link96);
      }

      if(this.customer.apple_114!==null){
        let link5 = document.createElement('link');
        link5.rel = "apple-touch-icon";
        link5.sizes = "114x114";
        link5.href = process.env.VUE_APP_STORAGE_BASE+this.customer.apple_114;
        document.head.appendChild(link5);
      }

      if(this.customer.apple_144!==null){
        let link6 = document.createElement('link');
        link6.rel = "apple-touch-icon";
        link6.sizes = "144x144";
        link6.href = process.env.VUE_APP_STORAGE_BASE+this.customer.apple_144;
        document.head.appendChild(link6);
      }

    }

  },
  beforeDestroy() {
    //clearTimeout(this.to);
  },
};
</script>
